var filters = {

    set_summary_occupancy : function(){
        var f = jQuery('#filter-group-occupancy .filter-summary');
        var a = parseInt(jQuery('#search-adults').val());
        var c = parseInt(jQuery('#search-children').val());
        var p = parseInt(jQuery('#search-pets').val());

        // guests = adults + children
        var o = (a + c) || 1;
        o += ' ' + (o==1 ? jQuery('#dataStrings').data('guest-singular') : jQuery('#dataStrings').data('guest-plural'));

        // pets
        if(p>0)
            o += ', ' + p + ' ' + (p==1 ? jQuery('#dataStrings').data('pet-singular') : jQuery('#dataStrings').data('pet-plural')) ;

        f.text(o).attr('title',o);
    },

    set_summary_rooms : function(){
        var f = jQuery('#filter-group-rooms .filter-summary');
        var bdmn = parseInt(jQuery('#minbeds').val()) || 0;
        var bdmx = parseInt(jQuery('#maxbeds').val());
        var btmn = parseInt(jQuery('#minbaths').val()) || 0;
        var btmx = parseInt(jQuery('#maxbaths').val());
        var o = jQuery('#dataStrings').data('any');

        // beds
        if(bdmx==bdmn && bdmn>0)
              o = bdmn + ' ' + (bdmn==1 ? jQuery('#dataStrings').data('bed-singular') : jQuery('#dataStrings').data('bed-plural'));
        else if(bdmx>0)
            o = bdmn + '-' + bdmx + ' ' + (bdmx==1 ? jQuery('#dataStrings').data('bed-singular') : jQuery('#dataStrings').data('bed-plural'));
        else if(bdmn>0)
            o = bdmn + ' ' + (bdmn==1 ? jQuery('#dataStrings').data('bed-singular') : jQuery('#dataStrings').data('bed-plural'));

        // baths
        if(btmx==btmn && btmn>0)
            o += ', ' + btmn + ' ' + (btmn==1 ? jQuery('#dataStrings').data('bath-singular') : jQuery('#dataStrings').data('bath-plural'));
        else if(btmx>0)
            o += ', ' + btmn + '-' + btmx + ' ' + (btmx==1 ? jQuery('#dataStrings').data('bath-singular') : jQuery('#dataStrings').data('bath-plural'));
        else if(btmn>0)
            o += ', ' + btmn + ' ' + (btmn==1 ? jQuery('#dataStrings').data('bath-singular') : jQuery('#dataStrings').data('bath-plural'));

        f.text(o).attr('title',o);
    },

    set_summary_dates : function(){
        var f = jQuery('#filter-group-dates .filter-summary');
        var d_exact = jQuery('#search-arrival, #search-departure').val() !== '';
        var d_range = jQuery(self.wz_element + ' select[name=nights], #flexStart, #flexEnd').val() !== '';
        var o = jQuery('#dataStrings').data('any');
        if(d_exact){
            var a = new Date(jQuery('#search-arrival').val());
            var d = new Date(jQuery('#search-departure').val());
            var s = (a.getMonth() + 1) + '/' + a.getDate();
            var e = (d.getMonth() + 1) + '/' + d.getDate();
            o = s + ' - ' + e;
        } else if(d_range) {
            var a = new Date(jQuery('#flexStart').val());
            var d = new Date(jQuery('#flexEnd').val());
            var s = (a.getMonth() + 1) + '/' + a.getDate();
            var e = (d.getMonth() + 1) + '/' + d.getDate();
            var n = jQuery('#flexNights').val();
            n = n + ' night' + (n==1?'':'s');
            //n = n + ' ' + (n==1 ? )
            o = n + ' in ' + s + ' - ' + e;
        }
        f.text(o).attr('title',o);
    },

    set_summary_price : function(){
        var f = jQuery('#filter-group-price .filter-summary');
        var mn = parseInt(jQuery('#minrate').val()) || 0;
        var mx = parseInt(jQuery('#maxrate').val());
        var o = jQuery('#dataStrings').data('any');
        if(mx==mn && mx>0)
            o = mx;
        else if(mx>0)
            o = mn+' - '+mx;
        else if(mn>0)
            o = mn+' +';
        f.text(o).attr('title',o);
    },

    set_summary_amenities : function(){
        var f = jQuery('#filter-group-amenities .filter-summary');
        var a = jQuery("#amenities input:checked");
        var o = jQuery('#dataStrings').data('any');
        if(a.length){
            o = '('+a.length+') ';
            a.each(function(i, e) {
                o += (i === 0 ? '' : ', ') + jQuery.trim(jQuery(this).parent().text());
            });
        }
        f.text(o).attr('title',o);
    },

    set_date_option : function(){
        var t = jQuery('input[name=datetype]:checked').val();
        if(!t) t = 'exact';
        if(t=='flex'){
            jQuery('#search-arrival, #search-departure').val('');
        } else {
            jQuery('#flexStart, #flexEnd, #flexNights').val('');
        }
        jQuery("#datetype-exact, #datetype-flex").hide();
        jQuery("#datetype-" + t).show();
    },

    filter_group_open : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            if(jQuery(this).is(':checkbox, :radio'))
                jQuery(this).data('oldVal',jQuery(this).attr('checked')?true:false);
            else
                jQuery(this).data('oldVal',jQuery(this).val());
        });
        jQuery('#'+id).addClass('open');
    },

    filter_group_cancel : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            if(jQuery(this).is(':checkbox, :radio'))
                jQuery(this).attr('checked',jQuery(this).data('oldVal')?true:false).removeData('oldVal');
            else
                jQuery(this).val(jQuery(this).data('oldVal')).removeData('oldVal');
        });
        jQuery('#'+id).removeClass('open changed');
    },

    filter_group_clear : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            var d = jQuery(this).data().hasOwnProperty("default");
            if(jQuery(this).is(':checkbox, :radio')){
                if(d)
                    jQuery(this).prop('checked',true).change();
                else
                    jQuery(this).prop('checked',false).change();
            } else {
                if(d)
                    jQuery(this).val(jQuery(this).data('default')).change();
                else
                    jQuery(this).val('').change();
            }
            $(".info-box").hide();
        });
        this.filter_group_update(id);
    },

    filter_group_update : function(id){
        jQuery('#'+id+' input, #'+id+' select').each(function(index, element) {
            jQuery(this).removeData('oldVal');
        });

        jQuery('#'+id).removeClass('open changed');

        //Reset the page number to 1 any time we update or clear search filters but NOT when display type changes
        jQuery("[name=pageNumber]").val(1);

        search_form.update();

        removePlaceholders();
        if(id == 'filter-group-occupancy' || id == 'filter-group-amenities') {
            this.set_summary_occupancy();
            this.set_summary_amenities();
        }
        else if(id == 'filter-group-rooms') {
            this.set_summary_rooms();
        }
        else if(id == 'filter-group-dates') {
            this.set_summary_dates();
        }
        else if(id == 'filter-group-price') {
            this.set_summary_price();
        }
        $(".info-box").hide();     
        addPlaceholders();
    },

    update_filters : function(){
        removePlaceholders();
        this.set_summary_occupancy();
        this.set_summary_rooms();
        this.set_summary_dates();
        this.set_summary_price();
        this.set_summary_amenities();
        this.set_date_option();
        jQuery("#filters-list li:not(.open).changed").removeClass('changed');
        addPlaceholders();
    },

    init : function(){
        var self = this;

        // set summaries and options
        self.update_filters();

        // open filter groups
        jQuery("#filters-list").on("click", "li:not(.open) .filters-head", function(e) {
            jQuery("#filters-list li.changed").each(function(index, element) {
                self.filter_group_update(jQuery(this).attr('id'));
            });
            jQuery("#filters-list li.open").removeClass('open');

            var id = jQuery(this).parent("li").attr('id');
            self.filter_group_open(id);
        });
        // cancel and close filter groups
        jQuery(".filters-cancel").click(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_cancel(id);
        });
        jQuery("#filters-list").on("click", "li.open .filters-head", function(e) {
            var id = jQuery(this).parent(".filter-group").attr('id');
            self.filter_group_cancel(id);
        });
        // clear filter group and update
        jQuery(".filters-clear").click(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_clear(id);
        });
        // update filters
        jQuery(".filters-update").click(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_update(id);
        });
        // switch date option
        jQuery("input[name=datetype]").change(function(e) {
            self.set_date_option();
        });
        jQuery("#filters-list input:not([name=datetype]), #filters-list select").change(function(e) {
            jQuery(this).parents(".filter-group").addClass("changed");
        });
        // set up counters
        jQuery(".filter-counter").each(function(index, element) {
            jQuery(this).find('.counter-btn-minus').click(function(e) {
                var v = jQuery(this).siblings('.counter-val');
                var val = parseInt(v.val()) || 0;
                if(v.data().hasOwnProperty("min") && val<=v.data('min')){}
                else if(val>0) v.val(val-1).change();
            });
            jQuery(this).find('.counter-btn-plus').click(function(e) {
                var v = jQuery(this).siblings('.counter-val');
                var val = parseInt(v.val()) || 0;
                if(v.data().hasOwnProperty("max") && val>=v.data('max')){}
                else v.val(val + 1).change();
            });
        });
        // discount toggle
        jQuery("#filter_discount").change(function(e) {
            var id = jQuery(this).parents(".filter-group").attr('id');
            self.filter_group_update(id);
        });

        // validate numerical fields. leave numbers and "-" (for negative numbers)
        jQuery(".filter-range-min, .filter-range-max, .counter-val").change(function(e) {
            var o = jQuery(this).val();
            if(o.match(/[^0-9\\-]+/g)){
                o = o.replace(/[^0-9\\-]+/g, '');
            }
            if(o === ''){
                if(jQuery(this).data().hasOwnProperty('default'))
                    o = jQuery(this).data('default');
            } else {
                o = parseInt(o);
            }
            jQuery(this).val(o);
        });
        // validate min/max constraints
        jQuery("input[data-min], input[data-max]").change(function(e) {
            if(jQuery.trim(jQuery(this).val()) !== ''){
                if(jQuery(this).val() < jQuery(this).data("min"))
                    jQuery(this).val(jQuery(this).data("min"));
                else if(jQuery(this).val() > jQuery(this).data("max"))
                    jQuery(this).val(jQuery(this).data("max"));
            }
        });
        // validate min is less than max
        jQuery(".filter-range-min, .filter-range-max").change(function(e) {
            if(jQuery(this).hasClass('filter-range-min')){
                var mn = parseInt(jQuery(this).val());
                var mx = parseInt(jQuery(this).siblings('.filter-range-max').val()) || 0;
            } else {
                var mn = parseInt(jQuery(this).siblings('.filter-range-min').val()) || 0;
                var mx = parseInt(jQuery(this).val());
            }
            if(mx > 0 && mn > mx){
                jQuery(this).siblings('.filter-range-min, .filter-range-max').val('');
            }
        });
        // link dog occupancy with dog friendly amenity
        jQuery("#search-pets").change(function(e){
            jQuery("#amenityPets").prop("checked", this.value > 0);
        });
        jQuery("#amenityPets").change(function(e){
            if(!jQuery(this).prop("checked")) {
                jQuery("#search-pets").val(0);
            } else if(jQuery("#search-pets").val() === 0) {
                jQuery("#search-pets").val(1);
            }
        });
        // auto update on search suggestion click
        jQuery("#rentals-container").on("click", ".suggestion-listing a", function(){
            search_form.update();
            self.update_filters();
        });
        // submit on enter pressed
        jQuery('#filters-list input').keypress(function(e) {
            // Enter pressed?
            if(e.which == 10 || e.which == 13) {
                jQuery(this).blur();
                var id = jQuery(this).parents(".filter-group").attr('id');
                self.filter_group_update(id);
                //search_form.update();
            }
        });
        jQuery("#search-location").change(function(e) {
            search_form.update('search');
        });
    }

};

jQuery(document).ready(function() {
    filters.init();
});




//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/searchbar.js
// module id = 13
// module chunks = 0